export default
    {
        guardaDieta:'/cocina/guardaDieta',
        listDieta:'/cocina/listDieta',

        guardaDietaGral:'/cocina/guardaDietaGral',
        listDietaGral:'/cocina/listDietaGral',
    }
